module.exports = __webpack_public_path__ + "img/mqttDTU3.db0755cb.jpg";